module.exports = __webpack_public_path__ + "58769670a7829235f7699f527ff204c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qp-2-right.png
// module id = 12
// module chunks = 0